<template>
  <table class="table-controls">
    <tbody>
    <AppTableControlsElem v-for="(item) in tableList"
                          :title="item.title"
                          :isActive="item.isActive"
                          :key="item.id"
                          @toggleActive="itemToggleActive(item.id)"/>
    </tbody>
  </table>
</template>

<script>
import AppTableControlsElem from './AppTableControlsElem.vue'

export default {
  name: 'app-table-controls',
  components: {
    AppTableControlsElem
  },
  props: {
    tableList: Array
  },
  methods: {
    itemToggleActive (itemId) {
      this.$emit('item-toggle', itemId)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

@import './_table-controls';
</style>
